import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

const authority = import.meta.env.VITE_COGNITO_AUTHORITY;
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;

/** True when both VITE_COGNITO_* build vars are set; otherwise the app renders without an auth gate. */
export const authEnabled = Boolean(authority && clientId);

/** Cognito Hosted UI OIDC config (authorization code + PKCE); redirects back to the current origin. */
export const oidcConfig: AuthProviderProps = {
  authority: authority ?? "",
  client_id: clientId ?? "",
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: "openid email profile",
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
